<template>
	<div class="template_box">
		<div class="content_box">
			
			<!-- 有失效卡 -->
			<div v-if="cardList && cardList.length  != 0" class="has_data">
				<div class="card_box" v-for="(item, index) in cardList" :key="item.card_id">
					<div class="card_text">
						<div class="top_box">
							<div class="TOZO_img">
								<img src="../../assets/card_list/TOZO.png" alt="">
							</div>
							<div class="card_id">ID：{{ item.card_id }}</div>
						</div>
						
						<div class="bottom_box">
							<div class="card_states">已过期</div>
							<div class="product_name">型号: {{ item.product_name }}</div>
							<div class="expire_date" v-if="item.expire_date">有效期: {{ item.expire_date }}</div>
						</div>
						
					</div>
					<div class="product_img">
						<img :src="item.product_img" alt="">
					</div>
				</div>
			</div>
			<!-- 无卡 -->
			<div v-else class="no_data">
				<div class="no_img">
					<img src="../../assets/card_list/Frame@2x.png" alt="">
				</div>
				<div class="no_text">暂无内容</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import { invalidwarrantycards, getvxuserinfo } from "../../plugins/api.js"

export default {
	name: 'myCardList',
	components: {  },
   data() {
		return {
			vx_open_id:'',
			cardList:[
				// {
				//    card_id: '1232189dhudhfh11ss', //卡ID
				//    product_name: 'TOZO Golden X1', //产品型号
				//    product_img: 'https://oss-gzh.tozo.com.cn/upload/202308231022171717_1692757337be0PhfykuQaZWnky.jpg', //产品图片                
				// }, 
				// {
				//    card_id: '1232189dhudhfhs111s', //卡ID
				//    product_name: 'TOZO Golden X1', //产品型号
				//    product_img: 'https://oss-gzh.tozo.com.cn/upload/202308231022171717_1692757337be0PhfykuQaZWnky.jpg', //产品图片                
				// }, 
			]
		}
   },
	
   mounted(){
		let StorageOpenid = localStorage.getItem("vx_open_id") ? localStorage.getItem("vx_open_id") : ''
		this.vx_open_id = this.$route.query.vx_open_id ? this.$route.query.vx_open_id : StorageOpenid
		
		if(this.vx_open_id){
			this.get_invalidwarrantycards()
		}else{
			// 获取URL中的code参数
			const code = new URLSearchParams(window.location.search).get('code');
			this.code = code
			if (code) {
			  // 获取到code，调用接口获取vx_open_id
			  this.get_vxuserinfo(code);
			}else{
				this.$root.$emit('authorize', { url: 'expireCardList' }); // 获取授权信息
			}
		}
   },
	
	methods: {
		//从后端获取vx_open_id
		async get_vxuserinfo(code){
			const fd = new window.FormData()
			fd.append("code", code)//微信用户vx_open_id
			await getvxuserinfo( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.vx_open_id = res.data.vx_open_id;
					localStorage.setItem('vx_open_id', this.vx_open_id)
					this.get_invalidwarrantycards()
				}
			}, (err) => {
			  console.log(err)
			})
		},
		
		//获取失效的保修卡
		get_invalidwarrantycards() {
			const fd = new window.FormData()
			fd.append("vx_open_id", this.vx_open_id)//微信用户vx_open_id
			invalidwarrantycards( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.cardList = res.data.list
				}else{
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: res.message });
				}
			}, (err) => {
				this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: err.message });
				console.log(err)
			})
		},
		
   }
}
</script>

<style lang='less' scoped>
@import url("css/cardList.css");
.bottom_box>.card_states{
	color: #FFFFFF;
}
.card_box{
	background: #999999;
}
</style>
